"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUpper = exports.hasSpecial = exports.hasNumber = exports.hasLower = exports.hasLength = exports.getValidationMessage = exports.default = exports.checkPassword = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const hasLower = secret => secret.length > 0 && new RegExp('[a-z]+').test(secret);
exports.hasLower = hasLower;
const hasUpper = secret => secret.length > 0 && new RegExp('[A-Z]+').test(secret);
exports.hasUpper = hasUpper;
const hasNumber = secret => secret.length > 0 && new RegExp('[0-9]+').test(secret);
exports.hasNumber = hasNumber;
const hasSpecial = secret => secret.length > 0 && new RegExp('[.*@_-]+').test(secret);
exports.hasSpecial = hasSpecial;
const hasLength = (min, max, secret) => secret.length >= min && secret.length <= max;
exports.hasLength = hasLength;
const checkPassword = secret => {
  let count = 0;
  count += hasLower(secret) ? 1 : 0;
  count += hasUpper(secret) ? 1 : 0;
  count += hasSpecial(secret) ? 1 : 0;
  count += hasNumber(secret) ? 1 : 0;
  return count >= 4;
};
exports.checkPassword = checkPassword;
const getValidationMessage = (secret, minLength, maxLength) => {
  const threeCheck = checkPassword(secret);
  const lenCheck = hasLength(minLength, maxLength, secret);
  const specialCheck = threeCheck || hasSpecial(secret);
  const numberCheck = threeCheck || hasNumber(secret);
  const lowerCheck = threeCheck || hasLower(secret);
  const upperCheck = threeCheck || hasUpper(secret);
  if (!lowerCheck) {
    return 'Must contain at least 1 or more lower case characters';
  }
  if (!upperCheck) {
    return 'Must contain at least 1 or more upper case characters';
  }
  if (!numberCheck) {
    return 'Must contain at least 1 or more numbers';
  }
  if (!specialCheck) {
    return 'Must contain at least 1 or more special characters (.,*,@,_,-)';
  }
  if (!lenCheck) {
    return `Must be ${minLength}-${maxLength} characters in length`;
  }
  return null;
};
exports.getValidationMessage = getValidationMessage;
class SecretRequirements extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {});
  }
  render() {
    const {
      secret,
      minLength,
      maxLength
    } = this.props;
    const lenCheck = hasLength(minLength, maxLength, secret);
    const threeCheck = checkPassword(secret);
    const specialCheck = threeCheck || hasSpecial(secret);
    const numberCheck = threeCheck || hasNumber(secret);
    const lowerCheck = threeCheck || hasLower(secret);
    const upperCheck = threeCheck || hasUpper(secret);
    const checkCssClass = 'check_circle_outline';
    const xCssClass = 'highlight_off';
    const iconCss = 'material-icons is-size-2 level-right';
    const textCss = 'login-rule level-left ';
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-check"
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "loginCheckPassLength",
      className: `level is-marginless ${lenCheck ? 'has-text-success' : ''}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: textCss
    }, "\xA0 Must be ", minLength, "-", maxLength, " characters in length"), /*#__PURE__*/_react.default.createElement("span", {
      className: `${iconCss} ${lenCheck ? 'has-text-success' : 'has-text-danger'}`
    }, lenCheck ? checkCssClass : xCssClass)), /*#__PURE__*/_react.default.createElement("div", {
      id: "loginCheckPassReqChars",
      className: `level is-marginless ${threeCheck ? 'has-text-success' : ''}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: textCss
    }, "\xA0 Must contain all of the following: "), /*#__PURE__*/_react.default.createElement("span", {
      className: `${iconCss} ${threeCheck ? 'has-text-success' : 'has-text-danger'}`
    }, threeCheck ? checkCssClass : xCssClass)), /*#__PURE__*/_react.default.createElement("div", {
      id: "loginCheckPassLower",
      className: `level is-marginless ${lowerCheck ? 'has-text-success' : ''}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: textCss
    }, " \xA0 - 1 lower case character"), /*#__PURE__*/_react.default.createElement("span", {
      className: `${iconCss} ${lowerCheck ? 'has-text-success' : 'has-text-danger'}`
    }, lowerCheck ? checkCssClass : xCssClass)), /*#__PURE__*/_react.default.createElement("div", {
      id: "loginCheckPassUpper",
      className: `level is-marginless ${upperCheck ? 'has-text-success' : ''}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: textCss
    }, " \xA0 - 1 upper case character"), /*#__PURE__*/_react.default.createElement("span", {
      className: `${iconCss} ${upperCheck ? 'has-text-success' : 'has-text-danger'}`
    }, upperCheck ? checkCssClass : xCssClass)), /*#__PURE__*/_react.default.createElement("div", {
      id: "loginCheckPassNumber",
      className: `level is-marginless ${numberCheck ? 'has-text-success' : ''}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: textCss
    }, " \xA0 - 1 number"), /*#__PURE__*/_react.default.createElement("span", {
      className: `${iconCss} ${numberCheck ? 'has-text-success' : 'has-text-danger'}`
    }, numberCheck ? checkCssClass : xCssClass)), /*#__PURE__*/_react.default.createElement("div", {
      id: "loginCheckPassSpecial",
      className: `level is-marginless ${specialCheck ? 'has-text-success' : ''}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: textCss
    }, " \xA0 - 1 special character (.,*,@,_,-)"), /*#__PURE__*/_react.default.createElement("span", {
      className: `${iconCss} ${specialCheck ? 'has-text-success' : 'has-text-danger'}`
    }, specialCheck ? checkCssClass : xCssClass))));
  }
}
SecretRequirements.propTypes = {
  secret: _propTypes.default.string,
  minLength: _propTypes.default.number,
  maxLength: _propTypes.default.number
};
SecretRequirements.defaultProps = {
  secret: '',
  minLength: 0,
  maxLenght: 0
};
var _default = exports.default = SecretRequirements;
//# sourceMappingURL=SecretRequirements.js.map